import http from '@/http'
const URL = '/admin/testimonials'

export const listTestimonials = async (params) => {
  const list = (await http.get(URL, { params: params }))
  return list
}

export const getTestimonial = async (id) => {
  let one = null
  if (id) {
    one = (await http.get(URL + `/${id}`))
  }
  return one
}

export const saveTestimonial = (payload) => {
  if (!payload.get('id')) {
    return http.post(URL, payload, { headers: { 'Content-Type': 'multipart/form-data' } })
  }
  return http.post(URL + `/${payload.get('id')}`, payload, { headers: { 'Content-Type': 'multipart/form-data' } })
}

export const changeStatus = (payload) => http.put(URL + `/${payload}/status`)

export const deleteTestimonial = async (id) => http.delete(URL + `/${id}`)

export const orderList = async (payload) => http.put(URL + `/reorder`, payload)

export default {
  listTestimonials,
  getTestimonial,
  saveTestimonial,
  changeStatus,
  deleteTestimonial,
  orderList
}
